import { Button } from '@nextui-org/react';
import {
  FaBoxOpen,
  FaEye,
  FaEyeSlash,
  FaShare,
  FaTrashCan,
} from 'react-icons/fa6';
import { LISTING_STATUS } from '../../../config/constants';
import { Listing } from '../../../data/types/listings';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PopupWithConfirmation } from '../../../components/popups';
import { useState } from 'react';

export const HideListingButton = ({
  store_id,
  listing,
  onActionSuccess,
  ListingsRepository,
}: {
  store_id?: number;
  listing?: Listing;
  ListingsRepository: any;
  onActionSuccess: (listingId: number) => void;
}) => {
  return (
    <Button
      color="primary"
      variant={
        store_id
          ? listing?.freezed_by_seller
            ? 'solid'
            : 'bordered'
          : listing?.listing_status_num === LISTING_STATUS.freezed_by_management
            ? 'solid'
            : 'bordered'
      }
      isIconOnly
      className="hover-clr-white mr-2"
      onClick={async () => {
        if (!listing) {
          return;
        }
        if (store_id) {
          if (listing.freezed_by_seller) {
            await ListingsRepository.unfreezeListing(store_id, listing?.id);
          } else {
            await ListingsRepository.freezeListing(store_id, listing?.id);
          }
        } else {
          if (listing.freezed_by_management) {
            await ListingsRepository.unfreezeListing(listing?.id);
          } else {
            await ListingsRepository.freezeListing(listing?.id);
          }
        }
        onActionSuccess(listing!.id);
      }}
    >
      {store_id ? (
        listing?.freezed_by_seller ? (
          <FaEye />
        ) : (
          <FaEyeSlash />
        )
      ) : listing?.listing_status_num ===
        LISTING_STATUS.freezed_by_management ? (
        <FaEye />
      ) : (
        <FaEyeSlash />
      )}
    </Button>
  );
};

export const DeleteListingButton = ({
  store_id,
  listing,
  ListingsRepository,
}: {
  store_id?: number;
  listing?: Listing;
  ListingsRepository: any;
}) => {
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(false);

  return (
    <>
      <Button
        className="mini-title mr-2"
        color="danger"
        variant="flat"
        style={{
          cursor: 'pointer',
          width: 40,
        }}
        onClick={async () => {
          setConfirmationModal(true);
        }}
        isIconOnly
      >
        <FaTrashCan />
      </Button>
      <PopupWithConfirmation
        open={confirmationModal}
        headerTitle={`Delete Listing #${listing?.id}?`}
        bodyText={`Are you sure you want to delete the listing "${
          listing?.name_en + ' - ' + listing?.name_ar
        }"? This action cannot be undone.`}
        buttonOneText={'Cancel'}
        buttonTwoText={'Delete'}
        onButtonOneClick={() => setConfirmationModal(false)}
        onButtonTwoClick={async () => {
          if (!listing) {
            return;
          }
          if (store_id) {
            await ListingsRepository.deleteListing(store_id, listing?.id).then(
              (res: boolean) => {
                if (!res) return;
                navigate('/products');
                setConfirmationModal(false);
              },
            );
          } else {
            toast.error(
              'You cannot delete this template. ERR: no store id found',
            );
          }
        }}
      />{' '}
    </>
  );
};

export const OpenListingDetailsButton = ({ listing }: { listing: Listing }) => {
  return (
    <Link to={`/products/listing-details/${listing?.id}`} target="_blank">
      <Button
        className="mini-title"
        color="warning"
        variant="flat"
        style={{
          cursor: 'pointer',
          width: 40,
        }}
        isIconOnly
      >
        <FaShare />
      </Button>
    </Link>
  );
};

export const ListingActionButtons = ({
  listing,
  onHideListingSuccess,
  store_id,
  ListingsRepository,
  showHideButton = true,
  showDeleteButton = true,
  showDetailsButton = true,
}: {
  listing: Listing;
  onHideListingSuccess: (valus: number) => void;
  store_id: number | undefined;
  ListingsRepository: any;
  showHideButton: boolean;
  showDeleteButton: boolean;
  showDetailsButton: boolean;
}) => {
  return (
    <div className="flex">
      {showHideButton && (
        <HideListingButton
          store_id={store_id}
          listing={listing}
          ListingsRepository={ListingsRepository}
          onActionSuccess={onHideListingSuccess}
        />
      )}
      {showDeleteButton && (
        <DeleteListingButton
          store_id={store_id}
          listing={listing}
          ListingsRepository={ListingsRepository}
        />
      )}
      {showDetailsButton && <OpenListingDetailsButton listing={listing} />}
    </div>
  );
};
